export default __webpack_public_path__ + "static/studio-slider-25-e2d4801e70042955d1c65c84587a0fe7.png";